import { P, Pivot, R } from "apparatus/library/common";
import { BasicShapes } from "apparatus/library/shapes/common";
import { Shape } from "paper";
export class Ellipse {
    constructor() {
        this.drivers = [
            {
                type: "rectangle",
                minX: 8, maxX: 300,
                minY: 8, maxY: 300,
                fromAppearance: a => P(a.width / 2, a.height / 2),
                toAppearance: (f, p) => f({ width: p.x * 2, height: p.y * 2 }),
                scale: 1.0,
                constraints(a, modifiers) {
                    if (modifiers.shift) {
                        // Force square.
                        const size = Math.max(a.width, a.height);
                        return { width: size, height: size };
                    }
                    return;
                }
            }
        ];
    }
    render(appearance) {
        let width = appearance.width;
        let height = appearance.height;
        if (appearance.forceCircle) {
            const max = Math.max(width, height);
            width = max;
            height = max;
        }
        const graphic = Shape.Ellipse(R(0, 0, width, height, Pivot.CENTER));
        BasicShapes.applyStyle(graphic, appearance);
        return {
            graphic: graphic,
            hitShape: graphic.rectHitShape(),
        };
    }
}
Ellipse.properties = {
    label: "Ellipse",
    defaultAppearance: Object.assign({ width: 120, height: 80, forceCircle: false }, BasicShapes.defaultAppearance),
    appearanceSpecs: [
        ...BasicShapes.specs,
        BasicShapes.header,
        {
            spec: "checkbox", key: "forceCircle", label: "Force circle shape",
        }
    ],
};
